import LayoutPadrao from 'lg-vue-components/layoutPadrao'

export default [
   {
      path: '/',
      redirect: 'configuracoes',
      component: LayoutPadrao,
      children: [
         {
            path: '/configuracoes',
            name: 'configuracoes',
            component: () => import('../pages/Configuracoes.vue')
         }
      ]
   }
]
